/**
 * Utilitaires géographiques partagés — source unique de vérité.
 *
 * Centralise les constantes et fonctions dupliquées à travers le codebase :
 *   - SIEGE_COORDS (était défini dans useProjectsData + useSchedulerData + lib/geo.ts)
 *   - calculateDistance (Haversine, était dans useProjectsData + useSchedulerData)
 *   - determineZone (grille tarifaire km → zone, idem)
 *   - getEntityColors (couleurs par entité parente, dans useProjectsData + useSchedulerData + AdminDivers)
 *
 * L'ancien fichier lib/geo.ts est supprimé (code mort, jamais importé).
 */

// ─── Coordonnées du siège social (22 rue André Citroen, 72000 Le Mans) ────

export const SIEGE_COORDS = { lat: 48.02915, lng: 0.17586 };

// ─── Distance à vol d'oiseau (Formule de Haversine) ───────────────────────

export const calculateDistance = (
  lat1: number, lon1: number,
  lat2: number, lon2: number,
): number => {
  const R = 6371; // Rayon de la Terre en km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
    Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

// ─── Zone tarifaire selon la distance au siège ─────────────────────────────

export const determineZone = (distance: number): string | number => {
  if (distance <= 5) return '1A';   // 0 à 5 km
  if (distance <= 10) return '1B';  // 5 à 10 km
  if (distance <= 20) return 2;     // 10 à 20 km
  if (distance <= 30) return 3;     // 20 à 30 km
  if (distance <= 40) return 4;     // 30 à 40 km
  if (distance <= 50) return 5;     // 40 à 50 km
  if (distance <= 65) return 6;     // 50 à 65 km
  if (distance <= 80) return 7;     // 65 à 80 km
  return 'GD';                      // > 80 km (Grand Déplacement)
};

// ─── Couleurs par entité parente ───────────────────────────────────────────

export const getEntityColors = (entity?: string | null) => {
  if (entity === 'JLO') return { bg: '#eff6ff', border: '#bfdbfe', text: '#1d4ed8', color: '#3b82f6', badge: '#dbeafe' };
  if (entity === 'WAG') return { bg: '#ecfdf5', border: '#86efac', text: '#047857', color: '#10b981', badge: '#d1fae5' };
  // Défaut (GP ou null) : vert
  return { bg: '#ecfdf5', border: '#86efac', text: '#047857', color: '#10b981', badge: '#d1fae5' };
};
